import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Redirect,
  Link,
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom'
import {
  InboxOutlined,
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import { getSurgeonList } from '../../store/action/surgeon.action'
import {
  Select,
  Row,
  Col,
  Button,
  Input,
  Breadcrumb,
  Form,
  message,
  Upload,
  Switch,
  Modal,
  Checkbox,
  Divider,
  Table,
  CheckboxGroup,
  Spin,
} from 'antd'
import { addEditUser } from '../../store/action/user.action'
import '../../css/users.scss'
import util from '../../util/util'
import { constants } from '../../constants'
import { fetchCompanyCustomers } from '../../store/action/customer.action'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import _ from 'lodash'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import profilelogo from '../../images/profile.jpg'
import { getHelp, pages } from '../../tutorials'
import { logout } from '../../store/action/profile.action'
var form = undefined
const UserAdd = (props) => {
  const [image, setImage] = useState(undefined)
  const [disabled, setDisabled] = useState(false)
  const [selectAll, setSelectAll] = useState(false)
  const [selectAllCustomer, setSelectAllCustomer] = useState(false)
  const [isActive, setIsActive] = useState(true)
  const [surgeon, setSurgeon] = useState(false)
  const [role, setRole] = useState({ value: null, children: null, key: null })
  const [customers, setCustomers] = useState(false)
  const [cadmin, setCadmin] = useState(props.user.role == constants.ROLE)
  const [options, setOptions] = useState([])
  var history = useHistory()
  var location = useLocation()
  var params = useParams()
  // When reached from the super-admin company detail page
  // (/companies/:id/users/...), return there; otherwise fall back to the
  // route-provided back path or the default users list.
  var backPath = params.id ? '/companies/' + params.id : props.back || '/users'
  var roleRef = useRef()
  var [modal, setModal] = useState(false)
  var [selectedList, setSelectedList] = useState([])
  var [hname, setHName] = useState()
  var [data, setData] = useState([])
  var [save, setSave] = useState(false)
  var [edited, setEdite] = useState(false)
  useEffect(() => {
    initializeForm()
    getHelp(pages.ADDUSER)
  }, [])

  useEffect(() => {
    if (
      role.value == constants.ROLE.MEDICAL_ASSOCIATE ||
      location.state?.role == constants.ROLE.MEDICAL_ASSOCIATE
    )
      props.fetchSurgeon(props.customer?._id)

    if (
      role.value == constants.ROLE.COMPANY_HEALTHCOACH ||
      location.state?.role == constants.ROLE.COMPANY_HEALTHCOACH
    )
      props.fetchCompanyCustomers(props.company?._id)
  }, [role])

  useEffect(() => setOptions(props.customers), [props.customers])
  useEffect(() => setOptions(props.surgeon), [props.surgeon])

  var renderOptions = () => {
    return options
      ? options.map((i, index) => {
          return <Select.Option value={i._id}>{i.name}</Select.Option>
        })
      : null
  }

  var initializeForm = () => {
    if (location.state) {
      var { userimage } = location.state
      setImage(userimage)
      if (
        location.state?.role == constants.ROLE.SURGEON ||
        location.state?.role == constants.ROLE.SUPER_ADMIN
      )
        setDisabled(location.state)
      setSurgeon(location.state?.role == constants.ROLE.MEDICAL_ASSOCIATE)
      setCustomers(location.state?.role == constants.ROLE.COMPANY_ADMIN)

      if (location.state?.role == constants.ROLE.COMPANY_HEALTHCOACH) {
        setRole({ key: 'Clinic', value: constants.ROLE.COMPANY_HEALTHCOACH })
        location.state.associateids = location.state?.associatecustomers
      }
      if (location.state?.role == constants.ROLE.MEDICAL_ASSOCIATE) {
        setRole({ key: 'Provider', value: constants.ROLE.MEDICAL_ASSOCIATE })
        location.state.associateids = location.state?.associatesurgeons
      }
      setIsActive(location.state?.active)

      form.setFieldsValue({
        ...location.state,
        associateids: location.state?.associateids || [],
        role: location.state?.role?.toString(),
        phone: location?.state?.phone ? '+' + location?.state?.phone + '' : '',
      })
    }
  }

  var handleChange = (info) => {
    if (info.file.status === 'done')
      util.getBase64(info.file.originFileObj, (image) => setImage(image))
  }

  var allselect = (e) => {
    return options ? options.map((i) => i._id) : []
  }
  const handleLogoutPrompt=(input,id)=>{
    Modal.confirm({
         title: 'Confirm',
         content:'You will be logged out for the recent changes to take effect. Would you like to continue?',
         okText: 'Yes',
         cancelText: 'No',
         onOk: async() =>{
           var response = await props.addEditUser(input, id)
          if(response)props.logoutapp()
         },
         onCancel: () => history.push(backPath),
       })
 }
  var handleSubmit = async (value) => {
    var input = JSON.parse(JSON.stringify({ ...value, active: isActive }))
    input.userimage = image
    input.customer = props.customer?._id
    input.company = props.company?._id
    input.role = util.convertRoleToNumber(input.role)
    input.phone = input.phone ?   input.phone : ''
    if(location?.state?._id==props.user?._id){
      handleLogoutPrompt(input, location.state?._id)
      return
    }
    var response = await props.addEditUser(input, location.state?._id)
    if (!response) return
    history.push(backPath)
  }

  const uploadButton = (
    <div className='uploadText'>
      <p className='ant-upload-drag-icon'>
        {/* <InboxOutlined /> */}
        <img
          src={profilelogo}
          height={100}
          width={100}
          className='profilelogo'
        />
      </p>
      <p className='ant-upload-text'>
        Click or drag file to this area to upload
      </p>
    </div>
  )

  const handleSave = async (value) => {
    const cdata = await renderModal(
      value.firstname + ' ' + value.lastname + ' ' + value.email,
      value.associateids
    )
    console.log('customer data', cdata)
    if (cdata[0]) setModal(value)
    else handleSubmit(value)
  }

  const renderModal = async (name, list = []) => {
    var seldata = []
    list.forEach((i) => {
      var cust = _.find(options, { _id: i })
      cust.associatehealthcoach[0] &&
        cust.associatehealthcoach[0]?._id != location.state?._id &&
        seldata.push({
          id: cust.associatehealthcoach[0]?._id,
          name: cust.name,
          oldH:
            (cust.associatehealthcoach[0]?.firstname || 'NA') +
            ' ' +
            (cust.associatehealthcoach[0]?.lastname || '') +
            ' ' +
            (cust.associatehealthcoach[0]?.email || ''),
          newH: name,
        })
    })
    console.log('selData', seldata)
    setData(seldata)
    return seldata
  }

  const dat = [
    {
      name: 'cust.firstname1',
      oldH: 'cust.associatehealthcoach.firstname1',
      newH: 'hname1',
    },
    {
      name: 'cust.firstname',
      oldH: 'cust.associatehealthcoach.firstname',
      newH: 'hname',
    },
  ]
  const columns = [
    {
      title: 'Clinic ',
      dataIndex: 'name',
      render: (text) => <p>{text}</p>,
    },
    {
      title: 'Present Health Coach',
      dataIndex: 'oldH',
      render: (text) => <p>{text}</p>,
    },
    {
      title: 'New Health Coach',
      dataIndex: 'newH',
      render: (text) => <p>{text}</p>,
    },
  ]

  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <Spin spinning={props.isLoading}>
      <Col className='userAddContainer'>
        <Row>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to={backPath}>Users</Link>
            </Breadcrumb.Item>
            {location.state ? (
              <Breadcrumb.Item>Edit</Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item>Add</Breadcrumb.Item>
            )}
          </Breadcrumb>
        </Row>
        <Row align='middle' className='headerRow'>
          <Col className='headerText'>Users</Col>
        </Row>
        <Form
          ref={(e) => (form = e)}
          layout={'vertical'}
          onFinish={(value) => {
            setSelectedList(value.associateids)
            setHName(value.firstname)
            role.value != constants.ROLE.COMPANY_HEALTHCOACH
              ? handleSubmit(value)
              : handleSave(value)
          }}
        >
          <Row gutter={20}>
            <Col flex='50%'>
              <div id={'userbasicdetailsform'}>
                <Form.Item
                  label='Email'
                  name='email'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      type: 'email',
                      message: 'Please valid enter email',
                    },
                  ]}
                >
                  <Input disabled={disabled} />
                </Form.Item>

                {/* {role.value == constants.ROLE.COMPANY_HEALTHCOACH && ( */}
                  <Form.Item
                    label='CELL PHONE'
                    name='phone'
                    rules={[
                      {
                        required: role.value == constants.ROLE.COMPANY_HEALTHCOACH ? true:false,
                        whitespace: true,
                        message: 'Please enter your cell number',
                      },
                      () => ({
                        validator(rule, value) {
                          var number = value
                            ? value.charAt(0) == '+'
                              ? value
                              : '+' + value
                            : ''
                          if (!value || isValidPhoneNumber(number)) {
                            return Promise.resolve()
                          }
                          return Promise.reject('Please enter valid number!')
                        },
                      }),
                    ]}
                  >
                    <PhoneInput className='phone-input' defaultCountry={'US'} enableAreaCodes />
                  </Form.Item>
                {/* )} */}

                <Form.Item
                  label='Firstname'
                  name='firstname'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Please enter firstname.',
                    },
                  ]}
                >
                  <Input disabled={disabled} maxLength={50} />
                </Form.Item>
                <Form.Item
                  label='Lastname'
                  name='lastname'
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: 'Please enter lastname.',
                    },
                  ]}
                >
                  <Input disabled={disabled} maxLength={50} />
                </Form.Item>
              </div>
              <div id={'userroleform'}>
                <Form.Item
                  label='Role'
                  name='role'
                  rules={[{ required: true, message: 'Please select a role.' }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    ref={roleRef}
                    onChange={(e, i) => {
                      console.log('dnenen', e, i)
                      setSurgeon(e == constants.ROLE.MEDICAL_ASSOCIATE)
                      setRole(i)
                    }}
                    disabled={disabled}
                  >
                    {props.customer && (
                      <Select.Option value={constants.ROLE.ADMIN}>
                        Admin
                      </Select.Option>
                    )}
                    {props.customer && (
                      <Select.Option value={constants.ROLE.PHYSIO}>
                        Therapist
                      </Select.Option>
                    )}
                    {props.customer && (
                      <Select.Option
                        key='Provider'
                        value={constants.ROLE.MEDICAL_ASSOCIATE}
                      >
                        Medical Associate
                      </Select.Option>
                    )}
                    {/* {!props.customer &&
                                    <Select.Option value={constants.ROLE.SUPER_ADMIN}>Super admin</Select.Option>} */}
                    {/* {props.customer  &&
                                        <Select.Option value={constants.ROLE.SURGEON}>Surgeon</Select.Option>}                                 */}
                    {!props.customer && (
                      <Select.Option
                        key='Clinic'
                        value={constants.ROLE.COMPANY_HEALTHCOACH}
                      >
                        Health Coach
                      </Select.Option>
                    )}
                    {!props.customer && (
                      <Select.Option value={constants.ROLE.COMPANY_ADMIN}>
                        Company Admin
                      </Select.Option>
                    )}
                  </Select>
                </Form.Item>
              </div>
              {(role.value == constants.ROLE.MEDICAL_ASSOCIATE ||
                role.value == constants.ROLE.COMPANY_HEALTHCOACH) && (
                <Form.Item
                  label={role.key}
                  name='associateids'
                  rules={[
                    {
                      required:
                        role.value != constants.ROLE.COMPANY_HEALTHCOACH,
                      message: 'Please select a ' + role.key?.toLowerCase(),
                    },
                  ]}
                >
                  <Select
                    mode='multiple'
                    style={{
                      width: '100%',
                    }}
                    disabled={disabled || !options}
                    loading={!options}
                    placeholder={'Please select ' + role.key?.toLowerCase()}
                    onChange={(e, i) => {
                      console.log(e)
                      if (e.length < options.length) setSelectAll(false)
                      if (e.length == options.length) setSelectAll(true)
                      if (e[e.length - 1] == 0) {
                        setSelectAll(true)
                        form.setFieldsValue({ associateids: allselect() })
                      }
                      if (e[e.length - 1] == 1) {
                        setSelectAll(false)
                        form.setFieldsValue({ associateids: [] })
                      }
                      if (e.length == 0) {
                        setSelectAll(false)
                      }
                      // if(i[0] && options[]) alert("Already assigned to this")
                    }}
                  >
                    {selectAll ? (
                      <Select.Option value={1}>Deselect all</Select.Option>
                    ) : (
                      <Select.Option value={0}>Select all</Select.Option>
                    )}
                    {renderOptions()}
                  </Select>
                </Form.Item>
              )}

              <Row gutter={10} align='top'>
                <Col style={{ marginTop: 6 }}>
                  <div>Status</div>
                </Col>
                <Col>
                  <Form.Item
                    name='active'
                    rules={[{ required: false, message: '' }]}
                  >
                    <Switch
                      checked={isActive}
                      disabled={disabled}
                      onChange={() => setIsActive(!isActive)}
                      checkedChildren={<CheckOutlined />}
                      unCheckedChildren={<CloseOutlined />}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col flex='50%'>
              <Row justify='center'>
                <div id={'userprofileform'}>
                  <Form.Item
                    name='userimage'
                    rules={[
                      { required: false, message: 'Please upload your image.' },
                    ]}
                  >
                    <Upload.Dragger
                      listType='picture-card'
                      disabled={disabled}
                      showUploadList={false}
                      onChange={handleChange}
                      customRequest={({ file, onSuccess }) =>
                        setTimeout(() => onSuccess('ok'), 0)
                      }
                    >
                      {image ? (
                        <img
                          className='uploadPrev'
                          src={image}
                          alt='avatar'
                          style={{ width: '100%' }}
                        />
                      ) : (
                        uploadButton
                      )}
                    </Upload.Dragger>
                  </Form.Item>
                </div>
              </Row>
              <Row justify='center'>
                {' '}
                {image && (
                  <DeleteOutlined style={{}} onClick={() => setImage('')} />
                )}
              </Row>
            </Col>
          </Row>
          {role.value == constants.ROLE.COMPANY_HEALTHCOACH && (
            <Modal
              width={570}
              okText='OK'
              okType='button'
              visible={modal}
              onOk={() => {
                setModal(false)
                handleSubmit(modal)
              }}
              onCancel={() => setModal(false)}
            >
              <Row>
                <b>
                  <i>Clinic to Health Coach Mapping. Override ?</i>
                </b>
                <Table columns={columns} dataSource={data || []} />
              </Row>
            </Modal>
          )}
          {!location.state && (
            <Row>
              <b>
                <i>*User will receive an email to set their password.*</i>
              </b>
            </Row>
          )}
          <Row justify='end'>
            <Form.Item>
              <Button
                id={'saveuser'}
                disabled={disabled}
                type='primary'
                htmlType='submit'
                className='submit-form-button'
              >
                {location.state ? 'Update' : 'Add'}
              </Button>
              <Button
                style={{ marginLeft: 20 }}
                type='primary'
                className='submit-form-button'
              >
                <Link to={backPath}>Cancel</Link>
              </Button>
            </Form.Item>
          </Row>
        </Form>
      </Col>
    </Spin>
  )
}

UserAdd.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.profile.isLoading,
    customers: state.customer.customers,
    customer: state.profile.customer,
    surgeon: state.surgeon.surgeons,
    user: state.profile.user,
    company: state.profile.company,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSurgeon: (customerid) => dispatch(getSurgeonList(customerid)),
    fetchCompanyCustomers: (companyid) =>
      dispatch(fetchCompanyCustomers(companyid)),
    addEditUser: (params, id) => dispatch(addEditUser(params, id)),
    logoutapp: () => dispatch(logout()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAdd)
